import { useEffect, useState } from 'react';

export const SpendingLimitBar = ({
  newPercentageSpent,
  prevPercentageSpent,
  animationDelayInMs,
}: {
  newPercentageSpent: number;
  prevPercentageSpent: number;
  animationDelayInMs: number;
}) => {
  const [fillProgressBar, setFillProgressBar] = useState(false);

  useEffect(() => {
    const amountBarTimeout = setTimeout(() => {
      setFillProgressBar(true);
    }, animationDelayInMs);

    return () => clearTimeout(amountBarTimeout);
  });

  return (
    <div className="relative mt-l h-s overflow-hidden rounded-s border border-structure-80">
      <span
        className="absolute left-0 top-0 block h-full rounded-s rounded-r-none bg-secondary-60"
        style={{ width: `${prevPercentageSpent}%` }}
      />
      {fillProgressBar && (
        <span
          className="absolute left-0 top-0 block h-full origin-left animate-fill-animation rounded-s rounded-r-none bg-secondary-60"
          style={{ width: `${newPercentageSpent}%` }}
        />
      )}
    </div>
  );
};
